import React, { FC, useEffect } from "react";
import { Button, Modal, Row, Col } from "react-bootstrap";
import * as serviceWorker from "./serviceWorkerRegistration";
import "./index.css";
import { Dialog } from "primereact/dialog";

const ServiceWorkerWrapper: FC = (props) => {
  const [showReload, setShowReload] = React.useState(false);
  const [waitingWorker, setWaitingWorker] =
    React.useState<ServiceWorker | null>(null);

  // Callback when a new service worker is waiting
  const onSWUpdate = (registration: ServiceWorkerRegistration) => {
    setShowReload(true);
    setWaitingWorker(registration.waiting);
  };

  // Callback when the service worker is successfully registered
  const onRegSuccess = () => {
    console.log("Service worker registered successfully.");
  };

  // Listen for the SW_WAITING message from the service worker
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data && event.data.type === "SW_WAITING") {
        console.log(
          "New service worker is waiting. Triggering update modal..."
        );
        setShowReload(true);
      }
    };

    navigator.serviceWorker.addEventListener("message", handleMessage);
    return () => {
      navigator.serviceWorker.removeEventListener("message", handleMessage);
    };
  }, []);

  // Register the service worker
  useEffect(() => {
    serviceWorker.register({
      onUpdate: onSWUpdate,
      onWaiting: onSWUpdate,
      onSuccess: onRegSuccess,
    });

    // Disable the blocker on localhost
    if (window.location.hostname === "localhost") {
      console.log("Running on localhost. Disabling service worker blocker.");
    }
  }, []);

  // Reload the page when the user confirms the update
  const reloadPage = () => {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: "SKIP_WAITING" });
      setShowReload(false);
      window.location.reload();
    }
  };

  return (
    <>
      <div className="toast-wrap">
        {/* Update Available Modal */}
        <Dialog
          header="Update Available"
          visible={showReload}
          closeOnEscape={false}
          closable={false}
          onHide={() => setShowReload(false)}
          maskClassName="update-mask"
          className="update-modal"
        >
          <Row className="mt-2">
            <Col xs={8}>
              <div className="text-left">
                A new version of the app is available. Please update to proceed.
              </div>
            </Col>
            <Col xs={4}>
              <Button onClick={reloadPage}>Update</Button>
            </Col>
          </Row>
        </Dialog>
        {props.children}
      </div>
    </>
  );
};

export default ServiceWorkerWrapper;
